import { atom } from 'jotai';

import type { Meeting } from '@/api/v4/meetings.api';
import type { IOption } from '@/types';

interface ActiveMeetingForm {
  id: Meeting['id'] | null;
  isDirty: boolean;
  shouldDiscard: boolean;
}

export interface ProjectOption extends IOption {
  createdFor: string | null;
}

export const activeMeetingFormState = atom<ActiveMeetingForm>({
  id: null,
  isDirty: false,
  shouldDiscard: false,
});

export const editedMeetingIdState = atom<string | null>(null);
